// extracted by mini-css-extract-plugin
export default {"host":"CAMSharedAssets_host__TbadZ","video":"CAMSharedAssets_video__LUX-l"};